import { useState, useEffect } from 'react'

export const fetcher = async (url) => {
  if (!url) {
    return
  }

  const apiToken = localStorage.getItem('apiToken')

  const response = await fetch(url, {
    headers: {
      'API_TOKEN': apiToken || '',
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    method: 'GET',
  })

  if (!response.ok) {
    const error = new Error('An error occurred while fetching the data.')
    throw error
  }

  const data = await response.json()

  return data
}

export function useFetch(url) {
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState(null)
  const [errorStr, setErrorStr] = useState('')

  useEffect(() => {
    async function makeFetch() {
      try {
        setIsLoading(true)
        const result = await fetcher(url)

        setData(result)
      } catch (error) {
        const errorString = error?.toString()
        setErrorStr(errorString)
        // eslint-disable-next-line no-console
        console.error(error)
      } finally {
        setIsLoading(false)
      }
    }

    makeFetch()
  }, [url])

  return { data, isLoading, error: errorStr }
}
